module.exports = __webpack_public_path__ + "img/frise-tn.fade09a7.jpg";